export default "__VITE_ASSET__BTdcAzbv__"